import {useMemo} from 'react'

import {useCommonFieldConfigurationContext as useFieldConfigurationContext} from '../../configuration/CommonConfigurationContext'
import {useTrucks} from '../trucks/useTrucks'

import {LoadSpacingScenario} from './types'

const defaultScenario: LoadSpacingScenario = {
  flowRate: false,
  loadSpace: false,
  timeOnJobSite: false
}

export const useLoadSpacingScenario = () => {
  const loadSpacingConfiguration = useFieldConfigurationContext('loadSpacing')
  const {isMultipleTruck} = useTrucks()
  return useMemo(() => {
    if (!loadSpacingConfiguration.isEnabled) {
      return defaultScenario
    }

    return loadSpacingConfiguration.scenarios[isMultipleTruck ? 'multipleTrucks' : 'singleTruck']
  }, [isMultipleTruck, loadSpacingConfiguration])
}
